import { formatPrice } from '@/utils/helper';

export default {
  name: 'OrderItemTable',
  props: {
    items: {
      default: () => ([]),
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      toggleAllDetail: false,
    };
  },
  computed: {
    openedRowDetail() {
      return this.toggleAllDetail ? this.items.map((i) => i.id) : [];
    },
    isAllDetailOpened() {
      return this.openedRowDetail.length === this.items.length;
    },
    checkedMemberMapping() {
      const mapping = {};
      this.items.forEach((item) => {
        mapping[item.id] = item.members.filter((member) => member.checked).length;
      });
      return mapping;
    },
  },
  methods: {
    columnThAttrs() {
      return {
        class: 'text-xs',
      };
    },
    formatPrice,
    itemRowClass(item) {
      if (this.openedRowDetail.includes(item.id)) {
        return 'item-table__row item-table__row--opened';
      }
      return 'item-table__row';
    },
    toggleAllMemberUnderItem(item) {
      const targetItem = this.items.find((i) => i.id === item.id);
      const isAllMemberChecked = this.checkedMemberMapping[item.id];

      targetItem.members = item.members.map((member) => {
        const newMember = { ...member };
        newMember.checked = !isAllMemberChecked;
        return newMember;
      });
    },
    sortOptions(options) {
      return [...options].sort((a, b) => a.index - b.index);
    },
    sortByEntree(a, b, isAsc) {
      const aName = a?.entree?.name || '';
      const bName = b?.entree?.name || '';
      const result = aName.localeCompare(bName);
      const direction = isAsc ? 1 : -1;
      return direction ? result * direction : result;
    },
    sortByNote(a, b, isAsc) {
      const aNote = (a?.entree?.options?.map(({ items = [] }) => items.map(({ name }) => name).join('')).join('') || '') + (a?.note || '');
      const bNote = (b?.entree?.options?.map(({ items = [] }) => items.map(({ name }) => name).join('')).join('') || '') + (a?.note || '');
      const result = aNote.localeCompare(bNote);
      const direction = isAsc ? 1 : -1;
      return direction ? result * direction : result;
    },
  },
};
